import { connect } from 'react-redux';
import { selectors as staffSelectors } from 'ducks/staff';
import PickSlip from './PickSlipLookup';
import React from 'react';
import { IPickSlipLookupProps } from './PickSlipLookup.properties';
import { IBasicLookupFieldHandle } from '@markinson/uicomponents-v2/BasicLookupField/BasicLookup.properties';

const mapStateToProps = (state) => ({
    DefaultWarehouse: staffSelectors.staff(state)?.defaultWarehouseEntity
});

const ConnectedComponent = connect(mapStateToProps, null)((props: Readonly<IPickSlipLookupProps>) => {
    return (<PickSlip
        {...props} />);
});

export default React.forwardRef(
    (props: Readonly<IPickSlipLookupProps>, ref: React.Ref<IBasicLookupFieldHandle>) => {

        return <ConnectedComponent {...props} fieldRef={ref} />;
    });
